import React from 'react';
import clsx from 'clsx';

/**
 * A labelled text input, matching the fields in the courier modals.
 *
 * Local to Mi Cuenta rather than in `components/ui/`: the project has this
 * markup copied by hand in several modals and unifying it is a pass of its own,
 * touching screens that already work. This keeps the three fields here
 * consistent without pretending to be that refactor.
 *
 * @param {object} props
 * @param {string} props.label
 * @param {string} [props.error] - Rendered under the field and reddens it.
 * @param {string} [props.hint] - Shown when there is no error.
 */
export const TextField = ({ label, error, hint, id, ...inputProps }) => (
  <div className="space-y-1.5">
    <label htmlFor={id} className="text-xs font-semibold text-text-secondary">
      {label}
    </label>
    <input
      id={id}
      aria-invalid={Boolean(error)}
      className={clsx(
        'w-full px-3 py-2 bg-white dark:bg-[#111] border rounded-xl text-sm dark:text-white',
        'focus:outline-none focus:ring-2 focus:border-transparent transition-all',
        error ? 'border-danger focus:ring-danger' : 'border-border focus:ring-ninja-green'
      )}
      {...inputProps}
    />
    {error ? (
      <p className="text-xs text-danger">{error}</p>
    ) : (
      hint && <p className="text-xs text-text-muted">{hint}</p>
    )}
  </div>
);
